import { Component, OnInit } from '@angular/core';
import { Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmbryoService } from 'src/app/Services/Embryo.service';

@Component({
  selector: 'app-cart-stock-validation-errors',
  templateUrl: './cart-stock-validation-errors.component.html',
  styleUrls: ['./cart-stock-validation-errors.component.scss'],
})
export class CartStockValidationErrorsComponent implements OnInit {
  @Input() product: any;
  lang: string = 'en';

  constructor(
    private embryoService: EmbryoService,
    public translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.embryoService.emitLang.subscribe((lang: string) => {
      if (this.lang !== lang) {
        this.lang = lang;
        this.translate.setDefaultLang(this.lang);
      }
    });
  }
}
